<template>
	<NuxtLink :to="link" class="shrink-0" :aria-label="name">
		<NuxtImg
			v-if="image"
			:src="image"
			:alt="name || ''"
			provider="storyblok"
			loading="lazy"
			format="webp"
			class="h-12 md:h-14 w-auto object-contain"
			height="56"
		/>
	</NuxtLink>
</template>

<script setup lang="ts">
interface Props {
	link?: string;
	name?: string;
	image?: string;
}

const { link = "", name = "", image = "" } = defineProps<Props>();
</script>
